import { STORM_FILE_ENVIRONMENT_IMAGE, STORM_FILE_EXPOSED_CODE } from "theme/config/constants";

import Image from "core-web/components/Image";
import PropTypes from "prop-types";
import React from "react";
import VideoPlayIcon from "theme/components/icons/VideoPlayIcon";
import Youtube from "core-web/components/Youtube";
import styled from "theme/libs/styled";

const ImageWrapper = styled("div")`
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
    width: 100%;
    height: 100%;
    background: ${({ theme }) => theme.colors.neutral_50};

    &[data-exposed-image="true"] {
        padding: 56px;

        ${({ theme }) => theme.above.tabletSm} {
            padding: 78px 98px 118px;
        }

        ${({ theme }) => theme.above.desktopSm} {
            padding: 144px;
        }
    }
`;

const Video = styled("video")`
    object-fit: cover;
    width: 100%;
    height: 100%;
    min-width: 100%;
    min-height: 100%;
`;

const YouTubeWrapper = styled("div")`
    width: 100%;
    height: 100%;

    iframe {
        height: 100%;
        width: 100%;
        max-width: 100%;
        max-height: 100%;
    }
`;

const StyledVideoPlayIcon = styled(VideoPlayIcon)`
    position: absolute;
    left: 50%;
    top: 48%;
    transform: translate3d(-50%, 0, 0);
    z-index: 3;
    border: none;
`;

const StyledImage = styled(Image)`
    object-fit: contain;
    border: none;
    font-style: italic;
    mix-blend-mode: multiply;

    &[data-environment="true"] {
        object-fit: cover;
    }
`;

const GalleryCard = ({ media, isLazyLoading }) => {
    const youTubeImageId = media.youtube?.split("/").pop() || undefined;
    const isExposedMedia = !media.code || media.code === STORM_FILE_EXPOSED_CODE;

    const imageWidths = [360, 560, 768, 1024, 1366, 1540, 1920, 2560];
    const imageSizes = ["100vw", "100vw", "100vw", "60vw", "60vw", "60vw", "60vw"];

    return (
        <>
            {!(media.youtube || media.video) && (
                <ImageWrapper data-exposed-image={isExposedMedia}>
                    {!!media.image && (
                        <StyledImage
                            key={media.title}
                            draggable="false"
                            loading={isLazyLoading ? "lazy" : "eager"}
                            alt={media.title}
                            title={media.title}
                            src={{ url: media.image, width: imageWidths, f: "webp", q: 80 }}
                            sizes={imageSizes}
                            fallbackImageAsPlaceholder={false}
                            data-environment={media.code === STORM_FILE_ENVIRONMENT_IMAGE}
                        />
                    )}
                </ImageWrapper>
            )}

            {media.video && (
                <Video loop playsInline autoPlay muted key={media.video}>
                    <source src={media.video} type="video/mp4" />
                </Video>
            )}

            {media.youtube && (
                <YouTubeWrapper>
                    <Youtube
                        embedUrl={media.youtube}
                        thumbnailSrc={`https://img.youtube.com/vi/${youTubeImageId}/sddefault.jpg`}
                        loading="lazy"
                    >
                        <StyledVideoPlayIcon height="64px" width="64px" />
                    </Youtube>
                </YouTubeWrapper>
            )}
        </>
    );
};

GalleryCard.propTypes = {
    isLazyLoading: PropTypes.bool,
    media: PropTypes.shape({
        code: PropTypes.string,
        image: PropTypes.string,
        title: PropTypes.string,
        video: PropTypes.string,
        youtube: PropTypes.string,
    }).isRequired,
};

GalleryCard.defaultProps = {
    isLazyLoading: true,
};

export default GalleryCard;
